import React from "react";

import SearchInputDelayed from "components/Inputs/SearchInput/SearchInputDelayed";

import { TypeIcon } from "components/Home/Utils/Utils";

import styles from "./utils.module.css";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import LightSlidersIcon from "images/Light Sliders icon purple.svg";

import { isEnabled } from "utils/featureFlags";
import { Button } from "aible";
import DatasetViewMenuButton from "@/components/Home/Utils/DatasetViewMenuButton";

export default class TopMenu extends React.PureComponent {
  render() {
    const {
      selected,
      selectHandler,
      searchHandler,
      options,
      isLoading,
      selectedFolder,
      isTableauMode,
      fetchingDatasetCount,
      search,
      showSettings,
      updateShowSettings,
      disabledViews
    } = this.props;

    const isSenseOnly =
      isEnabled("aible-sense") &&
      !isEnabled("chat-aible-consumer") &&
      !isTableauMode &&
      !isEnabled("aible-explore") &&
      !isEnabled("aible-optimize");

    return (
      <div className={styles.topMenuWrapper}>
        <div className={styles.topMenu}>
          {options && !isSenseOnly ? (
            <div className={styles.topMenuTabs}>
              {options.map((option) => {
                if (!option) return "";
                const value = option.value !== undefined ? option.value : option.text;
                return (
                  <TopMenuTab
                    {...option}
                    isLoading={selectedFolder !== undefined && isLoading && isLoading[value] === true}
                    key={value}
                    value={value}
                    selected={value === selected}
                    onClick={selectHandler ? () => selectHandler(value) : undefined}
                    disabled={disabledViews.includes(value)}
                  />
                );
              })}
            </div>
          ) : (
            ""
          )}
          <div
            className={styles.topMenuExpansion}
            style={{ minWidth: isEnabled("spark-agents-templates-view") ? "178px" : "unset" }}
          >
            {fetchingDatasetCount > 0 && (
              <div className={styles.loadMessage}>
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    transform: "scale(0.6)"
                  }}
                />
              </div>
            )}
            {!isEnabled("spark-agents-templates-view") && ["data", "agent templates"].includes(selected) && (
              <DatasetViewMenuButton />
            )}
            {selected === "chat" || selected === "new chat" ? (
              <div>
                <Button
                  className={styles.settingsButton}
                  type={"secondary"}
                  onClick={() => {
                    updateShowSettings(!showSettings);
                  }}
                  active={showSettings}
                  style={{
                    fontSize: "13px",
                    padding: "9px 18px"
                  }}
                  greyscaleDefaultState={true}
                >
                  <img src={LightSlidersIcon} className={styles.settingsIcon} />
                  {"Chat Options"}
                </Button>
              </div>
            ) : (
              searchHandler && (
                <SearchInputDelayed
                  value={search}
                  onChange={(value) => searchHandler(value)}
                  inputClass={styles.topMenuSearch + " " + (isTableauMode ? styles.isTableauMode : "")}
                  iconClass={styles.topMenuSearchClose}
                  responsive
                />
              )
            )}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

class TopMenuTab extends React.PureComponent {
  render() {
    const { value, text, icon, isLoading, selected, onClick, disabled } = this.props;

    let retText = text;

    return (
      <div
        id={"menuTab_" + value}
        className={
          (onClick ? styles.topMenuTab : styles.topMenuTabNoHover) +
          (selected ? " " + styles.selected : "") +
          (disabled ? " " + styles.topMenuTabDisabled : "")
        }
        onClick={!disabled ? onClick : undefined}
      >
        {icon === undefined && value !== "all" ? (
          isLoading ? (
            <LoadingIndicator style={{ width: "35px", transform: "scale(0.30)", margin: "0px" }} />
          ) : (
            <TypeIcon type={value} size={"24px"} isMenu background={"transparent"} padding={"1px 0px 0px 0px"} />
          )
        ) : icon ? (
          icon
        ) : (
          ""
        )}
        <p
          className={icon === undefined && value !== "all" ? styles.hideMobile : ""}
          style={{
            paddingLeft: "5px"
          }}
        >
          {retText}
        </p>
      </div>
    );
  }
}
